import { Tabs, TabsKinds } from "@minervaproject/fds/es/components/tabs";
import React, { useState } from "react";

import { WorkbookQuestions } from "./workbook_questions";

import { WorkbookAnswers } from "components/breakout_control_room/workbook_answers";
import { BreakoutRoomType } from "shared/types";

function WorkbookFlavors({
  breakoutRoomsByFlavor,
  type,
  shareResourceBetweenGroups,
  hasOneResourceForAllFlavorsAndGroups = false,
}: {
  breakoutRoomsByFlavor: { [flavor: string]: BreakoutRoomType[] };
  type: "questions" | "answers";
  shareResourceBetweenGroups: boolean;
  hasOneResourceForAllFlavorsAndGroups?: boolean;
}) {
  const flavors = Object.keys(breakoutRoomsByFlavor);
  const [selectedTab, setSelectedTab] = useState(flavors[0]);

  return (
    <div>
      <Tabs
        className="pb2 pl4"
        kind={TabsKinds.Dark}
        tabs={flavors.map((flavor) => [flavor, flavor])}
        currentTab={selectedTab}
        setCurrentTab={setSelectedTab}
      />
      {type === "questions" && (
        <WorkbookQuestions
          flavor={selectedTab}
          hasOneResourceForAllFlavorsAndGroups={hasOneResourceForAllFlavorsAndGroups}
        />
      )}
      {type === "answers" && (
        <WorkbookAnswers
          breakoutRooms={breakoutRoomsByFlavor[selectedTab]}
          flavor={selectedTab}
          shareResourceBetweenGroups={shareResourceBetweenGroups}
          hasOneResourceForAllFlavorsAndGroups={hasOneResourceForAllFlavorsAndGroups}
        />
      )}
    </div>
  );
}

export { WorkbookFlavors };
